import { motion } from "framer-motion";
import { SHIFT } from "@/constants/testIds";

export default function TheShift() {
  return (
    <section
      id="shift"
      data-testid={SHIFT.root}
      className="relative bg-[#ffffff] border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-3">
            <div className="flex items-center gap-3 font-mono text-[12px] uppercase tracking-[0.3em] text-black/65">
              <span className="eyebrow-bar" aria-hidden="true" />
              <span>The Shift</span>
            </div>
          </div>
          <div className="md:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tightest max-w-4xl text-[#0a0a0a]"
            >
              You're wondering if you should still be
              <span className="italic font-light text-black/65"> paying for people.</span>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: 0.15 }}
              className="mt-10 md:mt-12 max-w-2xl font-sans text-black/70 text-lg md:text-xl leading-relaxed"
            >
              You should — when those people now do the work of ten. Give a capable
              team the right AI and throughput climbs: the operators who win this
              decade are scaling output, not quietly trimming headcount.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
}
